/**
 * The Chrome glyph the product draws next to every "install the extension"
 * gesture: a circle, its iris, and three spokes. One source for every dashboard
 * site (ExtensionInstallBanner, DemoBanner), and the same paths the marketing
 * site's ChromeIcon draws (OverlayQALaunch src/pages/AccessibilityCheckerPage.tsx),
 * so the two surfaces cannot drift.
 *
 * Decorative by construction (`aria-hidden`): the accessible name always comes
 * from the label beside it. Size it from the call site via `className`.
 */
export function ChromeIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="4" />
      <line x1="21.17" x2="12" y1="8" y2="8" />
      <line x1="3.95" x2="8.54" y1="6.06" y2="14" />
      <line x1="10.88" x2="15.46" y1="21.94" y2="14" />
    </svg>
  );
}
